var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUserAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "8b4cwrdjxa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 16,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.646 4.167A3.095 3.095 0 0 0 5.52 7.292a3.095 3.095 0 0 0 3.125 3.124 3.095 3.095 0 0 0 3.125-3.125 3.095 3.095 0 0 0-3.125-3.125zm5.312 11.875v-1.25a3.095 3.095 0 0 0-3.125-3.126H6.458a3.095 3.095 0 0 0-3.125 3.125v1.25c0 .375.25.625.625.625s.625-.25.625-.625v-1.25c0-1.062.813-1.875 1.875-1.875h4.375c1.063 0 1.875.813 1.875 1.875v1.25c0 .375.25.625.625.625s.625-.25.625-.625zm-7.187-8.75c0 1.062.812 1.874 1.875 1.874a1.842 1.842 0 0 0 1.875-1.875 1.842 1.842 0 0 0-1.875-1.875A1.842 1.842 0 0 0 6.77 7.292zm9.687 1.874h1.25c.375 0 .625.25.625.625s-.25.625-.625.625h-1.25v1.25c0 .375-.25.625-.625.625s-.625-.25-.625-.625v-1.25h-1.25c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h1.25v-1.25c0-.375.25-.625.625-.625s.625.25.625.625v1.25z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#8b4cwrdjxa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserAdd);
export default __webpack_public_path__ + "static/media/ic-user-add.9ff2681e4555ad45881671922001aea3.svg";
export { ForwardRef as ReactComponent };